export const localUrlMapping = [
    {
        url: 'localhost',
        institutionId: '999021',
        cxUrl: 'http://localhost:5100',
        flow: '2',
        singleColumnLayout: false,
        pkceAuthUrl: 'https://mygeorgia.stage.examplecu.com/sts/connect/authorize?response_type=code&client_id=mygeorgia:creditsnap:f2d8a71e&redirect_uri=https://mygacu-cxd.creditsnap.com/s&scope=openid profile open-api:customerpersonal:read&code_challenge={{codechallenger}}&code_challenge_method=S256'
    }
];

export const qaUrlMapping = [
    {
        url: 'testing-cxd.creditsnap.com',
        institutionId: 'ABC',
        cxUrl: 'https://abc-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'abc-qa-cxd.creditsnap.com',
        institutionId: 'ABC',
        cxUrl: 'https://abc-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
            url: 'abc-qa-cxd2.creditsnap.com' ,
            institutionId: 'ABC',
            cxUrl: 'https://abc-cx.creditsnap.com',
            flow: '2',
            singleColumnLayout: true
    },
    {
        url: 'bfecu-qa-cxd.creditsnap.com',
        institutionId: 'BFECU',
        cxUrl: 'https://bfecu-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'scu-qa-cxd.creditsnap.com',
        institutionId: 'SCU',
        cxUrl: 'https://scu-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'nyufcu-qa-cxd.creditsnap.com',
        institutionId: 'NYUFCU',
        cxUrl: 'https://nyufcu-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'nasa-qa-cxd.creditsnap.com',
        institutionId: 'NASA',
        cxUrl: 'https://nasa-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },

    {
        url: 'ssetfcu-qa-cxd.creditsnap.com',
        institutionId: 'SSETFCU',
        cxUrl: 'https://ssetfcu-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'mygacu-qa-cxd.creditsnap.com',
        institutionId: 'MYGACU',
        cxUrl: 'https://mygacu-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true,
        pkceAuthUrl: 'https://mygeorgia.stage.examplecu.com/sts/connect/authorize?response_type=code&client_id=mygeorgia:creditsnap:f2d8a71e&redirect_uri=https://mygacu-qa-cxd.creditsnap.com/s&scope=openid profile open-api:customerpersonal:read&code_challenge={{codechallenger}}&code_challenge_method=S256'
    },
    {
        url: 'abc-qa-cxd2.creditsnap.com',
        institutionId: 'ABC',
        cxUrl: 'https://abc-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'memcu-qa-cxd.creditsnap.com',
        institutionId: 'MEMCU',
        cxUrl: 'https://memcu-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'expree-qa-cxd.creditsnap.com',
        institutionId: 'EXPREE',
        cxUrl: 'https://expree-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'dpfcu-qa-cxd.creditsnap.com',
        institutionId: 'DPFCU',
        cxUrl: 'https://dpfcu-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'fmocu-qa-cxd.creditsnap.com',
        institutionId: 'FMOCU',
        cxUrl: 'https://aurora-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'bwuccu-qa-cxd.creditsnap.com',
        institutionId: 'BWUCCU',
        cxUrl: 'https://bwuccu-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'ohecu-qa-cxd.creditsnap.com',
        institutionId: 'OHECU',
        cxUrl: 'https://ohecu-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'uno-qa-cxd.creditsnap.com',
        institutionId: 'UNO',
        cxUrl: 'https://uno-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'xfcu-qa-cxd.creditsnap.com',
        institutionId: 'XFCU',
        cxUrl: 'https://xfcu-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'profed-qa-cxd.creditsnap.com',
        institutionId: 'PROFED',
        cxUrl: 'https://profed-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'lcefcu-qa-cxd.creditsnap.com',
        institutionId: 'LCEFCU',
        cxUrl: 'https://lcefcu-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'sfcu-qa-cxd.creditsnap.com',
        institutionId: 'SFCU',
        cxUrl: 'https://sfcu-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: '999021-qa-cxd.creditsnap.com',
        institutionId: '999021',
        cxUrl: 'https://999021-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '999022-qa-cxd.creditsnap.com',
        institutionId: '999022',
        cxUrl: 'https://999022-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '2422-qa-cxd.creditsnap.com',
        institutionId: '2422',
        cxUrl: 'https://2422-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '802-qa-cxd.creditsnap.com',
        institutionId: '802',
        cxUrl: 'https://802-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '802b-qa-cxd.creditsnap.com',
        institutionId: '802B',
        cxUrl: 'https://802b-qa-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: '202002-qa-cxd.creditsnap.com',
        institutionId: '202002',
        cxUrl: 'https://202002-qa-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
];

export const stagingUrlMapping = [
    {
        url: 'abc-stg-cxd.creditsnap.com',
        institutionId: 'ABC',
        cxUrl: 'https://abc-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'abc2-stg-cxd.creditsnap.com',
        institutionId: 'ABC',
        cxUrl: 'https://abc3-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: false
    },
    {
        url: 'scu-stg-cxd.creditsnap.com',
        institutionId: 'SCU',
        cxUrl: 'https://scu-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'fmocu-stg-cxd.creditsnap.com',
        institutionId: 'FMOCU',
        cxUrl: 'https://fmocu-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'nasa-stg-cxd.creditsnap.com',
        institutionId: 'NASA',
        cxUrl: 'https://nasa-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'xfcu-stg-cxd.creditsnap.com',
        institutionId: 'XFCU',
        cxUrl: 'https://xfcu-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'profed-stg-cxd.creditsnap.com',
        institutionId: 'PROFED',
        cxUrl: 'https://profed-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'sfcu-stg-cxd.creditsnap.com',
        institutionId: 'SFCU',
        cxUrl: 'https://sfcu-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'memcu-stg-cxd.creditsnap.com',
        institutionId: 'MEMCU',
        cxUrl: 'https://memcu-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '2422-stg-cxd.creditsnap.com',
        institutionId: '2422',
        cxUrl: 'https://2422-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '802-stg-cxd.creditsnap.com',
        institutionId: '802',
        cxUrl: 'https://802-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '802b-stg-cxd.creditsnap.com',
        institutionId: '802B',
        cxUrl: 'https://802b-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: true
    },
    {
        url: '999021-stg-cxd.creditsnap.com',
        institutionId: '999021',
        cxUrl: 'https://999021-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '999022-stg-cxd.creditsnap.com',
        institutionId: '999022',
        cxUrl: 'https://999022-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'ssetfcu-stg-cxd.creditsnap.com',
        institutionId: 'SSETFCU',
        cxUrl: 'https://ssetfcu-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'dpfcu-stg-cxd.creditsnap.com',
        institutionId: 'DPFCU',
        cxUrl: 'https://dpfcu-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'dpfcu-stg-cxd.creditsnap.com',
        institutionId: 'DPFCU',
        cxUrl: 'https://dpfcu-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'mygacu-stg-cxd.creditsnap.com',
        institutionId: 'MYGACU',
        cxUrl: 'https://mygacu-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'ohecu-stg-cxd.creditsnap.com',
        institutionId: 'OHECU',
        cxUrl: 'https://ohecu-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'expree-stg-cxd.creditsnap.com',
        institutionId: 'EXPREE',
        cxUrl: 'https://expree-stg-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '202002-stg-cxd.creditsnap.com',
        institutionId: '202002',
        cxUrl: 'https://202002-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'ohecu-stg-cxd.creditsnap.com',
        institutionId: 'OHECU',
        cxUrl: 'https://ohecu-stg-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
];

export const uatUrlMapping = [
    {
        url: 'abc-cxd.creditsnap.com',
        institutionId: 'ABC',
        cxUrl: 'https://abc-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'bfecu-cxd.creditsnap.com',
        institutionId: 'BFECU',
        cxUrl: 'https://bfecu-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'scu-cxd.creditsnap.com',
        institutionId: 'SCU',
        cxUrl: 'https://scu-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'nyufcu-cxd.creditsnap.com',
        institutionId: 'NYUFCU',
        cxUrl: 'https://nyufcu-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'nasa-cxd.creditsnap.com',
        institutionId: 'NASA',
        cxUrl: 'https://nasa-cxu.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },

    {
        url: 'ssetfcu-cxd.creditsnap.com',
        institutionId: 'SSETFCU',
        cxUrl: 'https://ssetfcu-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'mygacu-cxd.creditsnap.com',
        institutionId: 'MYGACU',
        cxUrl: 'https://mygacu-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true,
        pkceAuthUrl: 'https://mygeorgia.stage.examplecu.com/sts/connect/authorize?response_type=code&client_id=mygeorgia:creditsnap:f2d8a71e&redirect_uri=https://mygacu-cxd.creditsnap.com/s&scope=openid profile open-api:customerpersonal:read&code_challenge={{codechallenger}}&code_challenge_method=S256'
    },
    {
        url: 'abc-cxd2.creditsnap.com',
        institutionId: 'ABC',
        cxUrl: 'https://abc-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'memcu-uat-cxd.creditsnap.com',
        institutionId: 'MEMCU',
        cxUrl: 'https://memcu-cxu.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'expree-cxd.creditsnap.com',
        institutionId: 'EXPREE',
        cxUrl: 'https://expree-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'dpfcu-cxd.creditsnap.com',
        institutionId: 'DPFCU',
        cxUrl: 'https://dpfcu-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'fmocu-cxd.creditsnap.com',
        institutionId: 'FMOCU',
        cxUrl: 'https://aurora-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },

    {
        url: 'bwuccu-cxd.creditsnap.com',
        institutionId: 'BWUCCU',
        cxUrl: 'https://bwuccu-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'ohecu-cxd.creditsnap.com',
        institutionId: 'OHECU',
        cxUrl: 'https://ohecu-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'uno-cxd.creditsnap.com',
        institutionId: 'UNO',
        cxUrl: 'https://uno-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'xfcu-cxd.creditsnap.com',
        institutionId: 'XFCU',
        cxUrl: 'https://xfcu-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'profed-cxd.creditsnap.com',
        institutionId: 'PROFED',
        cxUrl: 'https://profed-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'lcefcu-cxd.creditsnap.com',
        institutionId: 'LCEFCU',
        cxUrl: 'https://lcefcu-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'sfcu-cxd.creditsnap.com',
        institutionId: 'SFCU',
        cxUrl: 'https://sfcu-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: '999021-cxd.creditsnap.com',
        institutionId: '999021',
        cxUrl: 'https://999021-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '999022-cxd.creditsnap.com',
        institutionId: '999022',
        cxUrl: 'https://999022-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '2422-cxd.creditsnap.com',
        institutionId: '2422',
        cxUrl: 'https://2422-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '802-cxd.creditsnap.com',
        institutionId: '802',
        cxUrl: 'https://802-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '202002-cxd.creditsnap.com',
        institutionId: '202002',
        cxUrl: 'https://202002-cx.creditsnap.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: '802b-cxd.creditsnap.com',
        institutionId: '802B',
        cxUrl: 'https://802b-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false
    },
];

export const prodUrlMapping = [
    {
        url: 'openaccount.dpfcu.org',
        institutionId: 'DPFCU',
        cxUrl: 'https://openaccount.dpfcu.org',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'newaccount.lionsharecu.org',
        institutionId: 'LSFCU',
        cxUrl: 'https://newaccount.lionsharecu.org',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'simplisavedeposits.memcu.com',
        institutionId: 'MEMCU',
        cxUrl: 'https://simplisavedeposits.memcu.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'openaccount.expree.org',
        institutionId: 'EXPREE',
        cxUrl: 'https://openaccount.expree.org',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'accountopening.akafmofcu.org',
        institutionId: 'FMOCU',
        cxUrl: 'https://accountopening.akafmofcu.org',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'mbrapply.nasafcu.com',
        institutionId: 'NASA',
        cxUrl: 'https://applycs.nasafcu.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'account.servicecu.org',
        institutionId: 'SCU',
        cxUrl: 'https://apply.servicecu.org',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'apply.ohecu.com',
        institutionId: 'OHECU',
        cxUrl: 'https://apply.ohecu.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'membership.bwuccu.com',
        institutionId: 'BWUCCU',
        cxUrl: 'https://membership.bwuccu.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'membership.bwuccu.com',
        institutionId: 'BWUCCU',
        cxUrl: 'membership.bwuccu.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'accountopening.bfecu.com',
        institutionId: 'BFECU',
        cxUrl: 'https://accountopening.bfecu.com/',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'accountopening.unofcu.org',
        institutionId: 'UNO',
        cxUrl: 'https://accountopening.unofcu.org',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'accountopening.sspfcu.com',
        institutionId: 'SSETFCU',
        cxUrl: 'https://accountopening.sspfcu.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'join.nyufcu.com',
        institutionId: 'NYUFCU',
        cxUrl: 'https://apply.nyufcu.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'accounts.gogulfwinds.com',
        institutionId: 'GW2',
        cxUrl: 'https://accounts.gogulfwinds.com',
        flow: '2',
        singleColumnLayout: true
    },
    {
        url: 'apply.xplorefcu.com',
        institutionId: 'XFCU',
        cxUrl: 'https://apply.xplorefcu.com',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'openaccount.profedcu.org',
        institutionId: 'PROFED',
        cxUrl: 'https://apply.profedcu.org',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'accounts.lcefcu.org',
        institutionId: 'LCEFCU',
        cxUrl: 'https://accounts.lcefcu.org',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'join.signaturefcu.org',
        institutionId: 'SFCU',
        cxUrl: 'https://apply.signaturefcu.org',
        flow: '1',
        singleColumnLayout: false
    },
    {
        url: 'openacct.mygacu.com',
        institutionId: 'MYGACU',
        cxUrl: 'https://openacct.mygacu.com',
        flow: '2',
        singleColumnLayout: true,
        pkceAuthUrl: 'https://online.mygacu.com/sts/connect/authorize?response_type=code&client_id=mygeorgia:creditsnap:f2d8a71e&redirect_uri=https://openacct.mygacu.com/s&scope=profile api:open-api openid open-api:customerpersonal:read&code_challenge={{codechallenger}}&code_challenge_method=S256'
    },
    {
        url: 'apply.cuofco.org',
        institutionId: '2422',
        cxUrl: 'https://apply.cuofco.org',
        flow: '2',
        singleColumnLayout: true,
    },
    {
        url: 'apply.ozarkfcu.com',
        institutionId: '802',
        cxUrl: 'https://apply.ozarkfcu.com',
        flow: '2',
        singleColumnLayout: true,
    },
    {
        url: 'apply.mccoy.com',
        institutionId: '202002',
        cxUrl: 'https://apply.mccoy.com',
        flow: '2',
        singleColumnLayout: true,
    },
    {
        url: '802b-prd-cxd.creditsnap.com',
        institutionId: '802B',
        cxUrl: '802-prd-cx.creditsnap.com',
        flow: '1',
        singleColumnLayout: false,
    },
    {
        url: 'deposit-demo.savvymoney.com',
        institutionId: '999021',
        cxUrl: 'https://lending-demo.savvymoney.com',
        flow: '2',
        singleColumnLayout: true
    },
];

export const appConfig = {
    s3Url: 'https://creditsnap-public.s3.us-east-1.amazonaws.com',
    nonRolloutInstitutions: [
        'IFS', 'LGRX', 'GESA', 'GW',
        'AA', 'AXOS', 'DFCU', 'AFCU', '5POINT', 'RJ', 'EFCU', 'WAY',
        'LSFCU', 'WECU', 'FMOCU', 'Brampton-Chrysler', 'moncton-chrysler', 'TOWER-CHRYSLER',
        'MARANELLO-ALFA-ROMEO', 'LEGGAT-CHEVROLET', 'OAKVILLE-ALFA-ROMEO', 'DODGE-RED-DEER',
        'SOUTHBANK-CHRYSLER', 'PCHEFCU', 'BFECU', 'SCU', 'XTRFIN', 'UNO', 'BWUCCU',
        'AURORA', '17412', 'NYUFCU', 'TCM', 'DLR-EXCITE',
        'DLR-NIAGARA', 'DLR-RMNM', 'EASTWEST', 'XFCU', 'VSCU'
    ],
};
